export default __webpack_public_path__ + "static/media/logo-app.efc59f4f.png";